import moment from 'moment'

import { createSelector } from 'reselect'

import { selectBusinessTravellerCurrentApprovalRequest } from './selectBusinessTravellerCurrentApprovalRequest'
import { isDateAndAirportsMatchApprovalRequest } from '../utils/approvalRequestUtils'
import { getFlightSearchParams } from 'selectors/flightsSelectors'

/**
 * Selector that determines if the active search flight segment is within the current approval policy
 *
 * @rereturn {boolean} - Returns true if the current flight search parameters match the current approval request
 */
export const isWithinCurrentFlightApprovalPolicy = createSelector(
  selectBusinessTravellerCurrentApprovalRequest,
  getFlightSearchParams,
  (currentApprovalRequest, flightSearchParams) => {
    if (!currentApprovalRequest || currentApprovalRequest.type !== 'flight') {
      return false
    }

    if (!flightSearchParams || flightSearchParams.itinerary?.length === 0) {
      return false
    }

    const legs = flightSearchParams.itinerary

    for (const leg of legs) {
      const segment = {
        departureAirport: {
          airportCode: leg.departureAirport,
        },
        arrivalAirport: {
          airportCode: leg.arrivalAirport,
        },
        checkinDate: moment(leg.departureDate),
      }

      // If any segment matches, return true
      if (isDateAndAirportsMatchApprovalRequest(currentApprovalRequest, segment)) {
        return true
      }
    }

    return false
  },
)
